import React from "react"
import WarehousePanel from "../../inventory/warehouses/panels/WarehousePanel";
import gql from "graphql-tag";
import {graphql} from "react-apollo";

const ShipFromWarehousePanel = (props) => {

  if (props.loading || props.error) return null;
  if (!props.data.shippingOrder) return null;
  return (
    <WarehousePanel 
      title="Ship From Warehouse"
      warehouseId={props.data.shippingOrder.warehouseId} 
      />
  )

}

const ORDER_WAREHOUSE_ID = gql`
  query shippingOrder($orderId:ID!) {
    shippingOrder(orderId:$orderId) {
      warehouseId
    }
  }
`;

const withQuery = graphql(ORDER_WAREHOUSE_ID, {
  options: (props) => ({
    fetchPolicy: "cache-only",
    variables: {
      orderId: props.orderId
    }
  })
})


export default withQuery(ShipFromWarehousePanel);